import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {CommissionImportRow} from "../../../../shared/interface/commission-import-row";
import {ReplaySubject} from "rxjs";
import {CommissionImportRowService} from "../../../../shared/services/commission-import-row.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {HttpErrorResponse} from "@angular/common/http";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {Sort} from "@angular/material/sort";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";
import {UserPermissions} from "../../../../shared/interface/user-permissions";

@Component({
  selector: 'app-all-commission-import-row-settled-list',
  templateUrl: './all-commission-import-row-settled-list.component.html',
  styleUrls: ['./all-commission-import-row-settled-list.component.scss']
})
export class AllCommissionImportRowSettledListComponent implements AfterViewInit, OnInit, OnDestroy {
@ViewChild('filtersForm') filtersForm: NgForm;
@ViewChild(MatPaginator) paginator: MatPaginator;

  userPermissions: ReplaySubject<UserPermissions>;
  initialFilters: any;
  rows: any[] = [];
  displayedColumns: string[] = [
    'ofwca' ,
    'partner',
    'policyNumber',
    'company',
    'insuranceCompany',
    'importer'
  ];
  totalData = 0;
  loadingData = true;
  selectedInsuranceCompanies: InsuranceCompany = null;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private commissionImportRowService: CommissionImportRowService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
) {
    this.userPermissions = auth.getUserPermissions();
    this.commissionImportRowService.rowSetteledListSubject
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      ).subscribe({
      next: (response: CountedAndPaginated<CommissionImportRow>) => {
        this.loadingData = false;
        this.rows = response.items;
        this.totalData = response.pagination.total;
      },
      error: (response: HttpErrorResponse) => {
        this.snack.open('Przy ładowaniu danych wystąpił błąd', response.status.toString(), {duration: 2000});
        this.loadingData = false;
      }
    });

    this.parseFilters();


  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      insuranceCompany: 'int',
      importer: 'int',
      policyNumber: 'string',
      company: 'int',
      ofwca: 'string',
      partner: 'string',
    }, filters);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.loadingData = true;
          this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
            page: event.pageIndex,
            pageSize: event.pageSize,
            ...this.filtersForm.value
          })]);

      });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
}

  sortChanged($event: Sort): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      sortBy: $event.active,
      sortOrder: $event.direction,
      page: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value
    })]);
}

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    return filters;
  }

  loadListData(): void {
    this.loadingData = true;
    this.commissionImportRowService.loadSettledList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters()
      );
  }

  filter(): void {
    if (this.loadingData) {
      return;
    }
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
}

  downloadReport(): void {
    this.commissionImportRowService.downloadSettledReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
}
}
